<template>
  <div>
    <div class="question">
      <kr-math
        :input="question.question"
        :safe="!question.questionIsHTML"
      ></kr-math>
      <template v-if="question.attachments && question.attachments.length != 0">
        <div class="marginTop20 fontBold">
          <i class="fa fa-paperclip marginRight8" aria-hidden="true"></i>QUESTION ATTACHMENT(S)
        </div>
        <div class="textLink">
          <div v-for="(file, idx) in question.attachments" class="flex">
            <i class="fa fa-file-image-o marginRight8" aria-hidden="true"></i>
            <a
              class="textLink"
              :href="file.url"
              target="_blank"
              download
              :aria-label="file.filename"
              >{{ file.filename }}</a
            >
          </div>
        </div>
      </template>

      <div class="marginTop20">
        <!-- <template v-for="(option,option_idx) in question.options">
				<div class="discussionOption flexOnly" :class="{'correct':option.isCorrect&&question.displayAnswer,'padding10 paddingLeft32':!option.isCorrect&&question.displayAnswer}">
					<i class="fa fa-check-circle" v-if="option.isCorrect&&question.displayAnswer"></i>
					<i class="fas fa-times-circle" v-if="!option.isCorrect&&question.displayAnswer"></i>
					<div class="fontBold marginRight5">{{option.key}}</div>
					<div v-if="option.contentIsHTML" v-html="option.content"></div>
					<div v-else>{{option.content}}</div>
				</div>
			</template> -->

        <template v-for="(option, option_idx) in question.optionKeys">
          <div
            class="discussionOption"
            :class="{
              correct: option.isCorrect && question.displayAnswer,
              'padding10 paddingLeft32':
                !option.isCorrect && question.displayAnswer,
            }"
          >
            <div class="flexOnly">
              <i
                v-if="option.isCorrect && question.displayAnswer"
                class="fa fa-check-circle marginRight8" aria-hidden="true"
              ></i>
              <i
                v-if="!option.isCorrect && question.displayAnswer"
                class="fas fa-times-circle marginRight8" aria-hidden="true"
              ></i>
              <div class="fontBold marginRight5">{{ option.key }}</div>
              <kr-math
                :input="question.options[option_idx].content"
                :safe="!question.options[option_idx].contentIsHTML"
              ></kr-math>
            </div>

            <div class="marginTop10" v-if="question.displayAnswerStatistics">
              <div class="discussion-bar">
                <template v-if="option.percent.toFixed(0) >= 10">
                  <div
                    class="barProgress"
                    :style="'width:' + option.percent.toFixed(0) + '%'"
                    :class="{
                      'colorGreenBg whiteText':
                        option.isCorrect && question.displayAnswer,
                      'colorRedBg whiteText':
                        !option.isCorrect && question.displayAnswer,
                    }"
                  >
                    <template> {{ option.percent.toFixed(0) }}% </template>
                  </div>
                </template>
                <template v-else>
                  <div class="col-xs-12">
                    <template> {{ option.percent.toFixed(0) }}% </template>
                  </div>
                </template>
              </div>
              <div class="marginTop10 flexOnly hidden-xs hidden-sm">
                <div class="responseFont col-xs-2 maxWidth100px">
                  {{ option.countAnswersPerOptionData }}
                  <template v-if="option.countAnswersPerOptionData <= 1">
                    Response
                  </template>
                  <template v-else>
                    Responses
                  </template>
                </div>
                <div class="discussion-buttons">
                  <template
                    v-for="(model, model_idx) in option.answersPerOption"
                  >
                    <template v-if="model.student">
                      <div
                        class="dropdown"
                        v-if="
                          (model.attachments &&
                            model.attachments.length != 0) ||
                            model.comment
                        "
                      >
                        <button
                          class="btn gradient btn-default subBtn marginBottom10"
                          id="popOver"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :aria-label="model.student.fullname"
                        >
                          {{ truncate(model.student.fullname) }};<i
                            class="far fa-comment-dots marginLeft8" aria-hidden="true"
                          ></i>
                        </button>
                        <div
                          class="dropdown-menu dropdown-disucssion padding10 fontBlack"
                          aria-labelledby="popOver"
                        >
                          <div>
                            <div class="flexOnly marginBottom5 align-items">
                              <i
                                class="fas fa-comments marginRight8 greyText" aria-hidden="true"
                              ></i>
                              <span class="lineHeight08 fontBold">
                                Elaboration
                              </span>
                            </div>
                            <div v-if="model.comment">
                              <span class="whiteSpacePreWrap">{{
                                truncate(model.comment, 400)
                              }}</span>
                              <template v-if="model.comment.length > 400">
                                <div
                                  class="blue pointer marginTop10"
                                  @click="openModelInfoModal(model, 'student')"
                                  aria-label="View More"
                                >
                                  View More
                                </div>
                              </template>
                            </div>
                            <div v-else>
                              -
                            </div>
                          </div>
                          <div class="marginTop20">
                            <div class="flexOnly marginBottom5 align-items">
                              <i
                                class="fas fa-paperclip marginRight5 greyText"
                              ></i>
                              <span class="lineHeight08 fontBold">
                                Attachment(s)
                              </span>
                            </div>
                            <div>
                              <template
                                v-if="
                                  model.attachments &&
                                    model.attachments.length != 0
                                "
                              >
                                <div
                                  class="flex maxHeight100px"
                                  v-for="(file, idx) in model.attachments"
                                >
                                  <span class="marginRight5">
                                    {{ idx + 1 }}.
                                  </span>
                                  <a
                                    :href="file.url"
                                    target="_blank"
                                    class="textLink"
                                    download
                                    :aria-label="file.filename"
                                  >
                                    {{ file.filename }}
                                  </a>
                                </div>
                                <template v-if="model.attachments.length > 4">
                                  <div
                                    class="blue pointer marginTop10"
                                    @click="
                                      openModelInfoModal(model, 'student')
                                    "
                                    aria-label="View More"
                                  >
                                    View More
                                  </div>
                                </template>
                              </template>
                              <template v-else>
                                -
                              </template>
                            </div>
                          </div>
                          <div
                            class="marginTop20 previewModelTeam"
                            v-if="testObj.others.applicationType == 'team'"
                          >
                            <div class="flexOnly marginBottom5 align-items">
                              <i class="fas fa-users marginRight8 greyText" aria-hidden="true"></i>
                              <span class="lineHeight08 fontBold"
                                >Team Members</span
                              >
                            </div>
                            <div class="maxHeight100px">
                              <ul v-for="(student, idx) in model.team.members">
                                <li>{{ student.displayName }}</li>
                              </ul>
                            </div>
                            <template v-if="model.team.members.length > 4">
                              <div
                                class="blue pointer"
                                @click="openModelInfoModal(model, 'student')"
                                aria-label="View More"
                              >
                                View More
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <template v-else>
                        <button
                          class="btn gradient btn-default subBtn marginBottom10 cursor-norm"
                          :aria-label="model.student.fullname"
                        >
                          {{ truncate(model.student.fullname) }}
                        </button>
                      </template>
                    </template>

                    <template v-else-if="model.team">
                      <div
                        class="dropdown"
                        v-if="
                          (model.attachments &&
                            model.attachments.length != 0) ||
                            model.comment
                        "
                      >
                        <button
                          class="btn gradient btn-default subBtn marginBottom10"
                          id="popOver"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :aria-label="model.team.name"
                        >
                          {{ truncate(model.team.name) }}<i
                            class="far fa-comment-dots marginLeft8" aria-hidden="true"
                          ></i>
                        </button>
                        <div
                          class="dropdown-menu dropdown-disucssion padding10 fontBlack"
                          aria-labelledby="popOver"
                        >
                          <div>
                            <div class="flexOnly marginBottom5 align-items">
                              <i
                                class="fas fa-comments marginRight8 greyText" aria-hidden="true"
                              ></i>
                              <span class="lineHeight08 fontBold"
                                >Elaboration</span
                              >
                            </div>
                            <div v-if="model.comment">
                              <span class="whiteSpacePreWrap">{{
                                truncate(model.comment, 400)
                              }}</span>
                              <template v-if="model.comment.length > 400">
                                <div
                                  class="blue pointer marginTop10"
                                  @click="openModelInfoModal(model)"
                                  aria-label="View More"
                                >
                                  View More
                                </div>
                              </template>
                            </div>
                            <div v-else>
                              -
                            </div>
                          </div>
                          <div class="marginTop20">
                            <div class="flexOnly marginBottom5 align-items">
                              <i
                                class="fas fa-paperclip marginRight8 greyText" aria-hidden="true"
                              ></i>
                              <span class="lineHeight08 fontBold"
                                >Attachment(s)</span
                              >
                            </div>
                            <div>
                              <template
                                v-if="
                                  model.attachments &&
                                    model.attachments.length != 0
                                "
                              >
                                <div
                                  class="flex maxHeight100px"
                                  v-for="(file, idx) in model.attachments"
                                >
                                  <span class="marginRight5"
                                    > {{ idx + 1 }}. </span
                                  >
                                  <a
                                    :href="file.url"
                                    target="_blank"
                                    class="textLink"
                                    download
                                    :aria-label="file.filename"
                                    > {{ file.filename }} </a
                                  >
                                </div>
                                <template v-if="model.attachments.length > 4">
                                  <div
                                    class="blue pointer marginTop10"
                                    @click="openModelInfoModal(model)"
                                    aria-label="View More"
                                  >
                                    View More
                                  </div>
                                </template>
                              </template>
                              <template v-else>
                                -
                              </template>
                            </div>
                          </div>
                          <div
                            class="marginTop20 previewModelTeam"
                            v-if="testObj.others.applicationType == 'team'"
                          >
                            <div class="flexOnly marginBottom5 align-items">
                              <i class="fas fa-users marginRight8 greyText" aria-hidden="true"></i>
                              <span class="lineHeight08 fontBold"
                                >Team Members</span
                              >
                            </div>
                            <div class="maxHeight100px">
                              <ul v-for="(student, idx) in model.team.members">
                                <li>{{ student.displayName }}</li>
                              </ul>
                            </div>
                            <template v-if="model.team.members.length > 4">
                              <div
                                class="blue pointer"
                                @click="openModelInfoModal(model)"
                                aria-label="View More"
                              >
                                View More
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <template v-else>
                        <div class="dropdown">
                          <button
                            class="btn gradient btn-default subBtn marginBottom10"
                            id="popOver"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            :aria-label="model.team.name"
                          >
                            {{ truncate(model.team.name) }}
                          </button>
                          <div
                            class="dropdown-menu dropdown-disucssion padding10 fontBlack"
                            aria-labelledby="popOver"
                          >
                            <div
                              class="previewModelTeam"
                              v-if="testObj.others.applicationType == 'team'"
                            >
                              <div class="flexOnly marginBottom5 align-items">
                                <i
                                  class="fas fa-users marginRight8 greyText" aria-hidden="true"
                                ></i>
                                <span class="lineHeight08 fontBold"
                                  > Team Members </span
                                >
                              </div>
                              <div class="maxHeight100px">
                                <ul>
								<template v-for="(student, idx) in model.team.members">
									<li>{{ student.displayName }}</li>
								</template>
                                </ul>
                              </div>
                              <template v-if="model.team.members.length > 4">
                                <div
                                  class="blue pointer"
                                  @click="openModelInfoModal(model)"
                                  aria-label="View More"
                                >
                                  View More
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
              <div class="hidden-md hidden-lg">
                <div class="responseFont marginTop10 ">
                  {{ option.countAnswersPerOptionData }}
                  <template v-if="option.countAnswersPerOptionData <= 1">
                    Response
                  </template>
                  <template v-else>
                    Responses
                  </template>
                </div>
                <div class="discussion-buttons marginTop10 ">
                  <template
                    v-for="(model, model_idx) in option.answersPerOption"
                  >
                    <template v-if="model.student">
                      <template
                        v-if="
                          (model.attachments &&
                            model.attachments.length != 0) ||
                            model.comment
                        "
                      >
                        <button
                          class="btn gradient btn-default subBtn marginBottom10"
                          @click="openModelInfoModal(model, 'student')"
                          :aria-label="model.student.fullname"
                        >
                          {{ truncate(model.student.fullname) }}<i
                            class="far fa-comment-dots marginLeft8" aria-hidden="true"
                          ></i>
                        </button>
                      </template>
                      <template v-else>
                        <button
                          class="btn gradient btn-default subBtn marginBottom10 cursor-norm"
                          :aria-label="model.student.fullname"
                        >
                          {{ truncate(model.student.fullname) }}
                        </button>
                      </template>
                    </template>

                    <template v-if="model.team">
                      <template
                        v-if="
                          (model.attachments &&
                            model.attachments.length != 0) ||
                            model.comment
                        "
                      >
                        <button
                          class="btn gradient btn-default subBtn marginBottom10"
                          @click="openModelInfoModal(model)"
                          :aria-label="model.team.name"
                        >
                          {{ truncate(model.team.name) }}<i
                            class="far fa-comment-dots marginLeft8" aria-hidden="true"
                          ></i>
                        </button>
                      </template>
                      <template v-else>
                        <button
                          class="btn gradient btn-default subBtn marginBottom10"
                          @click="openModelInfoModal(model)"
                          :aria-label="model.team.name"
                        >
                          {{ truncate(model.team.name) }}
                        </button>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- <template v-if="!question.displayAnswerStatistics">
		<template v-if="question.studentAnswered || question.teamsAnswered">
			<div class="mini-panel panel col-xs-12 col-md-10 hidden-xs hidden-sm marginTop20">
				<template v-if="question.studentAnswered">
					<div class="panel-heading flexSpaceBetween">
						<div>SUBMITTED ({{question.studentAnswered.length}})</div>
					<div><a class="link">View All&nbsp;<i class="fa fa-caret-right"></i></a></div>
					</div>
					<div class="panel-body flex">
						<template v-for="(student,student_idx) in question.studentAnswered">
							<div class="btnSections">
								<button class="btn gradient btn-default subBtn">
									Student {{student.fullname}}&nbsp;<i class="fa fa-user"></i>
								</button>
							</div>
						</template>
					</div>
				</template>
				<template v-if="question.teamsAnswered">
					<div class="panel-heading flexSpaceBetween">
						<div>SUBMITTED ({{question.teamsAnswered.length}})</div>
					<div><a class="link">View All&nbsp;<i class="fa fa-caret-right"></i></a></div>
					</div>
					<div class="panel-body flex">
						<template v-for="(team,team_idx) in question.teamsAnswered">
							<div class="btnSections buttonGroup">
								<button class="btn gradient btn-default subBtn" @click="openTeamInfoModal(team)">
									{{team.name}}&nbsp;<i class="fa fa-users"></i>
								</button>
							</div>
						</template>
					</div>
				</template> 
			</div>
			<div class="mini-panel panel hidden-md hidden-lg marginTop20">
				<template v-if="question.studentAnswered">
					<div class="panel-heading flexSpaceBetween">
						<div>SUBMITTED ({{question.studentAnswered.length}})</div>
					<div><a class="link">View All&nbsp;<i class="fa fa-caret-right"></i></a></div>
					</div>
					<div class="panel-body">
						<template v-for="(student,student_idx) in question.studentAnswered">
							<div class="btnSections">
								<button class="btn gradient btn-default subBtn">
									Student {{student.fullname}}&nbsp;<i class="fa fa-user"></i>
								</button>
							</div>
						</template>
					</div>
				</template>
				<template v-if="question.teamsAnswered">
					<div class="panel-heading flexSpaceBetween">
						<div>SUBMITTED ({{question.teamsAnswered.length}})</div>
					<div><a class="link">View All&nbsp;<i class="fa fa-caret-right"></i></a></div>
					</div>
					<div class="panel-body">
						<template v-for="(team,team_idx) in question.teamsAnswered">
							<div class="btnSections">
								<button class="btn gradient btn-default subBtn" @click="openTeamInfoModal(team)">
									{{team.name}}&nbsp;<i class="fa fa-users"></i>
								</button>
							</div>
						</template>
					</div>
				</template> 
			</div>
		</template>
	</template> -->
    <!-- <div class="marginTop20" v-if="question.displayAnswerStatistics">
		<div class="flex">
			<div class="mini-panel panel col-xs-12">
				<div class="panel-heading flexSpaceBetween">
					<div>ANSWER CHOICES</div>
				</div>
				<div class="panel-body flex">
					<table class="barChart">
						<tbody class="body">
							<template v-for="(option,option_idx) in question.optionKeys">
								<tr>
									<div class="percentage" :style="'bottom:'+((option.percent.toFixed(0)/100)*80)+'%'">{{round(option.percent)}}%</div>
									<td class="bars" :class="{'correct':option.isCorrect&&question.displayAnswer,'wrong':!option.isCorrect&&question.displayAnswer,'default':!question.displayAnswer}" :style="'height:'+((option.percent.toFixed(0)/100)*80)+'%;'"></td>
									<td class="record">
										<div class="marginBottom10">Choice {{option.key}}</div>
										<template v-for="(model,model_idx) in option.answersPerOption">
											<template v-if="model.student">
												<div class="btnDiscussionTeams">
													<button class="btn btn-discussionTeams subBtn">
														{{model.student.fullname}}&nbsp;<i class="fa fa-user"></i>
													</button>
												</div>
											</template>
											<template v-if="model.team">
												<div class="btnDiscussionTeams">
													<button class="btn btn-discussionTeams subBtn" @click="openTeamInfoModal(model.team)">
														{{model.team.name}}&nbsp;<i class="fa fa-users"></i>
													</button>
												</div>
											</template>
										</template>
										<button class="btn subBtn marginLeft0 fontSize12">
											<span>More</span>&nbsp;<i class="fa fa-sort-down"></i>
										</button>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div> -->
    <div
      :id="'eGalleryTeamInfoModal' + question.uuid"
      class="modal"
      style="z-index:50001!important;"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'eGalleryTeamInfoModal' + question.uuid + '-title'"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            
            <h4 :id="'eGalleryTeamInfoModal' + question.uuid + '-title'" class="modal-title" v-if="previewModel.type == 'team'">
              View {{ previewModel.team.name }}
            </h4>
            <h4 class="modal-title" v-if="previewModel.type == 'student'">
              View {{ previewModel.student.fullname }}
            </h4>
          </div>
          <div class="modal-body">
            <div>
              <div class="flexOnly marginBottom5 align-items">
                <i class="fas fa-comments marginRight8 greyText" aria-hidden="true"></i>
                <span class="lineHeight08 fontBold">Elaboration</span>
              </div>
              <div v-if="previewModel.comment">
                <span class="whiteSpacePreWrap">{{
                  previewModel.comment
                }}</span>
              </div>
              <div v-else>
                -
              </div>
            </div>
            <div class="marginTop20">
              <div class="flexOnly marginBottom5 align-items">
                <i class="fas fa-paperclip marginRight8 greyText" aria-hidden="true"></i>
                <span class="lineHeight08 fontBold">Attachment(s)</span>
              </div>
              <div>
                <template
                  v-if="
                    previewModel.attachments &&
                      previewModel.attachments.length != 0
                  "
                >
                  <div
                    class="flex"
                    v-for="(file, idx) in previewModel.attachments"
                  >
                    <span class="marginRight5">{{ idx + 1 }}.</span>
                    <a
                      :href="file.url"
                      target="_blank"
                      class="textLink"
                      download
                      :aria-label="file.filename"
                      >{{ file.filename }}</a
                    >
                  </div>
                </template>
                <template v-else>
                  -
                </template>
              </div>
            </div>
            <div
              class="marginTop20 previewModelTeam"
              v-if="previewModel.type == 'team'"
            >
              <div class="flexOnly marginBottom5 align-items">
                <i class="fas fa-users marginRight8 greyText" aria-hidden="true"></i>
                <span class="lineHeight08 fontBold">Team Members</span>
              </div>
              <div>
                <ul v-for="(student, idx) in previewModel.team.members">
                  <li>{{ student.displayName }}</li>
                </ul>
              </div>
            </div>
            <div class="col-xs-12 marginTop20 buttonGroup">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["testObj", "question", "options"],
  data() {
    return {
      previewModel: {
        type: "team",
        student: {},
        team: {},
        comment: {},
        attachments: [],
      },
    };
  },
  methods: {
    openModelInfoModal(model, type = "team") {
      var that = this;
      if (type == "team") {
        this.previewModel.type = "team";
        this.previewModel.team = model.team;
      } else {
        this.previewModel.type = "student";
        this.previewModel.student = model.student;
      }
      this.previewModel.comment = model.comment;
      this.previewModel.attachments = model.attachments
        ? model.attachments
        : [];
      $("#eGalleryTeamInfoModal" + this.question.uuid).modal("show");

      $("#eGalleryTeamInfoModal" + this.question.uuid).on(
        "hidden.bs.modal",
        function() {
          that.previewModel = {
            type: "team",
            student: {},
            team: {},
            comment: {},
            attachments: [],
          };
        }
      );
    },
    truncate(str, characters = 10) {
      return _.truncate(str, {
        length: characters,
        omission: "...",
      });
    },
  },
};
</script>

<style>
body.test .panel {
  height: 100%;
}
</style>

<style scoped>
.discussionOption {
  margin-top: 20px;
  line-height: 1.2;
  padding: 10px;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
}

.discussionOption.correct {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #f3fffd;
  border: 1px solid #29cb97;
  border-radius: 3px;
  padding: 10px;
}

.discussionOption .fa-check-circle {
  color: #29cb97;
  margin-right: 10px;
}

.discussionOption .fa-times-circle {
  color: #d8d8d8;
  margin-right: 10px;
}

body.test .mini-panel .panel-heading {
  font-size: 14px;
}

body.test .mini-panel .panel-heading .link {
  /* color: #1991eb; */
  text-transform: capitalize;
}

@media (min-width: 992px) {
  .btnSections {
    margin: 5px;
  }
}

@media (max-width: 991px) {
  .btnSections {
    margin-top: 10px;
  }
  .btnSections:first-child {
    margin-top: 0;
  }
}

body.test .discussion .panel,
body.test .mini-panel.panel {
  box-shadow: 0 0 2px 0 rgba(202, 202, 202, 0.5);
}

body.test .mini-panel.panel {
  margin-bottom: 0;
}

.commentTeams {
  white-space: normal;
}

.commentTeams div {
  margin-top: 15px;
}

.commentTeams div:first-child {
  margin-top: 0;
}

.goodAnswerDiv .btn,
.goodAnswerDiv .statusTag {
  margin-left: 10px;
}

.goodAnswerDiv .btn:first-child {
  margin-left: 0;
}
table.barChart {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  height: 330px;
  height: 330px;
  position: relative;
  overflow: auto;
  border: none;
  box-shadow: none;
}

.barChart .bars {
  display: flex;
  flex-direction: column;
}

.barChart .bars tr {
  flex-grow: 1;
}

.barChart .bars td {
  text-align: center;
  display: block;
  margin-right: 0.5em;
  line-height: 0em;
}

.barChart .bars td::after {
  content: "";
  height: 1px;
  width: 100%;
  background: black;
  position: absolute;
}

.barChart .body {
  display: flex;
  flex-grow: 1;
  height: 200px;
  border-bottom: 2px solid #d8d8d8;
}

.barChart .body tr {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-grow: 1;
  flex-basis: 0;
  margin: 0 2% 0 0;
  position: relative;
  width: 150px;
  height: 200px;
}

.barChart .body tr:first-child {
  margin-left: 2%;
}

.barChart .record {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 200px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1991eb;
  font-weight: bold;
  line-height: 1;
}

.barChart .bars {
  background: #989b9c;
  display: block;
  width: 30px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: 0;
  max-height: 184px;
}

.barChart .percentage {
  position: absolute;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
}

.barChart tr:nth-child(6n + 1) .btn-discussionTeams {
  background: #e48b3a;
}
.barChart tr:nth-child(6n + 2) .btn-discussionTeams {
  background: #4e669b;
}
.barChart tr:nth-child(6n + 3) .btn-discussionTeams {
  background: #81359f;
}
.barChart tr:nth-child(6n + 4) .btn-discussionTeams {
  background: #428459;
}
.barChart tr:nth-child(6n + 5) .btn-discussionTeams {
  background: #bfa677;
}
.barChart tr:nth-child(6n + 6) .btn-discussionTeams {
  background: #ba4747;
}
.btnDiscussionTeams {
  margin-top: 10px;
}

.btnDiscussionTeams:first-child {
  margin-top: 0;
}
.barChart .bars.correct {
  background: #0f9b81;
}
.barChart .bars.wrong {
  background: #dc3c42;
}
.barChart .bars.default {
  background: grey;
}

.responseFont {
  /* margin-top:8px; */
  margin-top: 0;
  margin-right: 10px;
  font-weight: bold;
}

.discussion-buttons .btn {
  margin-left: 0;
  margin-right: 20px;
}

.discussionOption:nth-child(6n + 1) .discussion-buttons button {
  background: #e48b3a;
  color: #fff;
}
.discussionOption:nth-child(6n + 2) .discussion-buttons button {
  background: #4e669b;
  color: #fff;
}
.discussionOption:nth-child(6n + 3) .discussion-buttons button {
  background: #81359f;
  color: #fff;
}
.discussionOption:nth-child(6n + 4) .discussion-buttons button {
  background: #428459;
  color: #fff;
}
.discussionOption:nth-child(6n + 5) .discussion-buttons button {
  background: #bfa677;
  color: #fff;
}
.discussionOption:nth-child(6n + 6) .discussion-buttons button {
  background: #ba4747;
  color: #fff;
}

.discussionOption .discussion-buttons button i {
  color: #fff;
}
</style>
